import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../service/api";
import { CodeInput } from "../../../components/CodeInput";
import { CustomModal } from "../../../components/CustomModal";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { Alert } from "../../../components/Alert";

export interface ImportMachineModalProps {
    open: boolean;
    onJoin: (id: number) => void;
    onClose: () => void;
}
export const ImportMachineModal = ({open, onJoin, onClose}: ImportMachineModalProps) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();


    useEffect(() => {
        setError('');
    }, [code]);

    const transfer = useCallback(() => {
        setLoading(true);
        API.POST('/api/admmachines', { invitationId: code })
            .then(({machineId}) => onJoin(machineId))
            .catch(err => {setError(err.message); })
            .finally(() => setLoading(false));

    }, [code]);

    useEffect(() => {
        if (!open) return;
        setCode('');
        setError('');
        setLoading(false);
    }, [open]);

    return (
        <CustomModal
            open={open}
            title={t('add_machine')}
            onClose={onClose}
            footer={(
                <MDBBtn disabled={code.length < 6 || loading} onClick={transfer}>
                    <MDBIcon icon="plus-circle" className="me-1"/>
                    {t('add')}
                </MDBBtn>
            )}
        >
            <h6>{t('insert_invitation_code')}:</h6>

            <div className="d-flex flex-row justify-content-center">
                <CodeInput onCodeChange={(c: string) => setCode(c)}/>
            </div>

            <Alert type="danger" message={error}/>
        </CustomModal>
    );
}